// extracted by mini-css-extract-plugin
export default {"overlay":"Qz-z","bodyOpen":"Rz-z","content":"Sz-z","header":"Tz-z","close":"Uz-z","closeNoHeading":"Vz-z"};